import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "overlay"
}
const _hoisted_3 = { class: "modal" }
const _hoisted_4 = { class: "challenge-header" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "checkmark"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = {
  key: 1,
  class: "overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header" }, "Please verify you are human", -1)),
      _createElementVNode("div", {
        class: "check",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openChallenge && _ctx.openChallenge(...args)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "checkbox" }, null, -1),
        _createElementVNode("span", null, "Click to verify", -1)
      ])),
      _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"margin-top":"20px"} }, " This verification helps ensure the security and performance of this website. ", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "footer" }, " Verification service enabled ", -1))
    ]),
    (_ctx.showOverlay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Select all images containing", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.prompts[_ctx.promptStage].question), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["image-wrapper", { selected: _ctx.selected.includes(img) }]),
                  onClick: ($event: any) => (_ctx.toggleSelectionImage(img))
                }, [
                  (_ctx.selected.includes(img))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " ✓ "))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: img,
                    draggable: "false"
                  }, null, 8, _hoisted_8)
                ], 10, _hoisted_6))
              }), 128))
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitPrompt && _ctx.submitPrompt(...args)))
              }, "VERIFY")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "modal" }, [
            _createElementVNode("div", { class: "success" }, [
              _createElementVNode("h2", null, "✓ Verification Complete"),
              _createElementVNode("p", null, "Loading portfolio..."),
              _createElementVNode("div", { class: "spinner" })
            ])
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}